import { render, staticRenderFns } from "./page19.vue?vue&type=template&id=0f42c9e6&scoped=true&"
import script from "./page19.vue?vue&type=script&lang=js&"
export * from "./page19.vue?vue&type=script&lang=js&"
import style0 from "./page19.vue?vue&type=style&index=0&id=0f42c9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42c9e6",
  null
  
)

export default component.exports